import api from './index'
import { axios } from '@/utils/request'

// 免登录获取token
export function getShareToken (params) {
  return axios(`${api.getShareToken}`, {params})
}

// 获取项目信息
export function getProjectInfo (projectId) {
  return axios(`${api.getProjectInfo}/${projectId}`)
}
// 获取在线率
export function getOnlineRate (ouId) {
  return axios(`${api.getOnlineRate}/${ouId}`)
}
// 获取行为风险和机体风险统计
export function getOperationMonitorHomeStat (params) {
  return axios({
    url: api.getOperationMonitorHomeStat,
    method: 'post',
    data: params
  })
}
// 获取风险排名
export function getListRiskRank (params) {
  return axios({
    url: api.getListRiskRank,
    method: 'post',
    data: params
  })
}
// 获取行为风险详情列表
export function getBehavioralRiskDetail (params) {
  return axios({
    url: api.getBehavioralRiskDetail,
    method: 'post',
    data: params
  })
}
// 获取机体风险详情列表
export function getBodyRiskDetail (params) {
  return axios({
    url: api.getBodyRiskDetail,
    method: 'post',
    data: params
  })
}
// 分布图静态数据
export function getSpreadStaticData (projectId) {
  return axios(`${api.getSpreadStaticData}/${projectId}`)
}
// 分布图动态数据
export function getSpreadRealData (params) {
  return axios({
    url: api.getSpreadRealData,
    method: 'post',
    data: params
  })
}
// 获取塔机接口参数
export function getProCraneStruct (projectId) {
  return axios(`${api.getProCraneStruct}/${projectId}`)
}
// 获取萤石token
export function getYSToken () {
  return axios({
    url: api.getYsToken,
    method: 'post'
  })
}
// 获取项目的视频列表
export function getProVideoList (projectId) {
  return axios({
    url: `${api.getProVideoList}/${projectId}`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/metric.js